<template>
  <section class="viewsrhqy_AccessCard space-y-2 p-4">
    <viewTitle title="业务管理 / 发卡退卡管理 / 发卡操作" :showReturn="false"/>
    <el-row type="flex" v-if="current_doors">
      <el-col :span="6" class="text-lg font-bold text-blue-500">
        门岗名称：{{ form.door_name }}
      </el-col>
      <el-col :span="18" class="text-lg font-bold text-blue-500">
        未发卡：{{ total || 0 }}
      </el-col>
    </el-row>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="预约单号">
        <el-input
            clearable
            v-model="queryParam.booking_code"
            placeholder="请输入预约单号"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="预约业务名称">
        <el-select
            clearable
            v-model="queryParam.business_id"
            placeholder="请选择"
        >
          <el-option
              v-for="item in business"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆业务类型">
        <el-select
            clearable
            v-model="queryParam.car_business_id"
            placeholder="请选择"
        >
          <el-option
              v-for="item in car_business"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input
            clearable
            v-model="queryParam.license_plate"
            placeholder="请输入车牌号"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
            clearable
            v-model="queryParam.order_code"
            placeholder="请输入订单号"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="呼叫时间">
        <el-date-picker
            class="!w-96"
            style="margin-bottom: 10px;"
            v-model="timeRange"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshData" size="small">刷新数据</el-button>
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
        class="mt-4"
        :isIndex="false"
        :isSelection="false"
        :selection.sync="rowKeySelection"
        :data="dataSource"
        :columns="columns"
        :query.sync="pagintion"
        :total="total"
        row-key="booking_id"
        @loadPage="loadData"
    >
      <template slot="call_finish_time" slot-scope="{ row }">
        {{ row.call_finish_time | timeFormat }}
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link v-has="['c-card-send-send']" @click="onSendCard(row)">发卡</c-link>
          <c-link @click="onView(row)">查看</c-link>
        </div>
      </template>
    </c-table>
    <el-dialog
        title="请选择门岗"
        :visible="door_visible"
        width="30%"
        :close-on-click-modal="false"
        :show-close="false"
    >
      <el-form label-width="100px">
        <el-form-item label="门岗" prop="door_id">
          <el-select
              value-key="id"
              v-model="current_doors"
              placeholder="请选择基地门岗"
          >
            <el-option
                v-for="item in doors"
                :key="item.id"
                :label="item.name"
                :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onDoorConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <AccessCardModal :showDoor="false" ref="accessCard" @ok="refreshData"/>
    <AccessCardDetail ref="AccessCardDetail"/>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import AccessCardModal from './components/AccessCardModal.vue'
import AccessCardDetail from "./components/AccessCardDetail.vue";
import {mapGetters} from 'vuex';

export default {
  props: [""],

  data() {
    return {
      business: [],
      car_business: [],
      door_visible: false,
      form: {},
      doors: [],
      current_doors: undefined,
      columns: [
        {label: "所属基地", prop: "base_name", formatData: () => this.baseInfo.com_name},
        {label: "预约号", prop: "code"},
        {label: "账号", prop: "account"},
        {label: "车辆业务类型", prop: "car_business_name"},
        {label: "车牌号", prop: "license_plate"},
        {label: "司机", prop: "driver_name"},
        {label: "呼叫时间", prop: "call_finish_time"},
        {label: "状态", prop: "state", formatData: () => '待进厂'},
        {label: "操作", prop: "action"},
      ],
      fetchDataEvent: params => {
        const {begin_time, end_time, ...data} = params;
        return this.$common.http({
          url: "/api/queue/admin/query_booking_card",
          data: {
            ...data,
            call_begin_time: begin_time,
            call_end_time: end_time,
            access_card_state: 1
          }
        })
      }
    };
  },

  computed: {
    ...mapGetters(["baseInfo"]),
  },

  watch: {},

  components: {
    AccessCardModal,
    AccessCardDetail
  },

  mixins: [initListMinxin, mixinTableLyout],

  beforeCreate() {
  },

  created() {
    this.getDoors();
    this.getBusiness();
  },

  beforeMount() {
  },

  mounted() {
  },

  activated() {
  },

  deactivated() {
  },

  methods: {
    getDoors() {
      this.$common
          .http({
            url: "/api/queue/admin/query_door",
            data: {
              page_size: 999,
              state: 1,
              keyword: ""
            }
          })
          .then(res => {
            this.doors = res.data.data.data;
            this.$nextTick(() => {
              this.door_visible = true;
            });
          });
    },
    onDoorConfirm() {
      if (!this.current_doors) {
        this.$common.pcToastFail(`门岗不能为空`);
        return;
      }
      this.form.door_id = this.current_doors.id;
      this.form.door_name = this.current_doors.name;
      this.door_visible = false;
    },
    onSendCard(row) {
      this.$refs.accessCard.onOpen(row.id, 1, this.current_doors);
    },
    onView(row) {
      this.$refs.AccessCardDetail.onOpen(row.id);
    },
    getBusiness() {
      this.$common.http({
        url: "/api/queue/admin/query_business",
        data: {
          state: 0,
          keyword: "",
          is_parent: 0,
          page_size: 999
        }
      }).then(res => {
        this.business = res.data.data.data;
      });

      this.$common.http({
        url: "/api/queue/admin/query_business",
        data: {
          state: 0,
          keyword: "",
          is_parent: 1,
          page_size: 999
        }
      }).then(res => {
        this.car_business = res.data.data.data;
      });
    },
  }
};
</script>
<style lang="less" scoped>
.viewsrhqy_AccessCard {
}
</style>
<style lang="less">
.viewsrhqy_AccessCard {
}
</style>
